import { render, staticRenderFns } from "./editDoctor.vue?vue&type=template&id=1aa0c1c0&scoped=true&"
import script from "./editDoctor.vue?vue&type=script&lang=js&"
export * from "./editDoctor.vue?vue&type=script&lang=js&"
import style0 from "./editDoctor.vue?vue&type=style&index=0&id=1aa0c1c0&prod&lang=scss&"
import style1 from "./editDoctor.vue?vue&type=style&index=1&id=1aa0c1c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0c1c0",
  null
  
)

export default component.exports